module.exports = __webpack_public_path__ + "img/VL_04_03.6ec6ccff.png";